var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _g, _path30, _g2, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @keyframes pulse {\n      0% {\n        transform: scale(1);\n      }\n      50% {\n        transform: scale(1.05);\n      }\n      100% {\n        transform: scale(1);\n      }\n    }\n\n    #animated-cloud {\n      animation: pulse 5s ease-in-out infinite;\n    }\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M451.35 279.683C451.014 277.94 450.665 276.217 450.303 274.517C441.138 231.432 422.69 186.93 389.8 156.56C375.552 143.404 358.322 133.361 339.118 129.743C315.675 125.326 291.305 131.444 269.769 141.703C248.233 151.962 228.9 166.216 208.938 179.275C196.049 187.707 182.417 195.833 167.211 198.284C149.001 201.219 130.366 195.723 112.004 197.468C83.2 200.205 57.817 221.684 47.444 248.695C37.071 275.706 40.824 307.055 54.499 332.554C68.174 358.053 91.044 377.911 116.84 391.017C152.593 409.182 194.871 414.858 233.745 405.003C252.704 400.196 271.084 391.795 290.64 391.447C314.901 391.016 337.625 403.018 361.662 406.334C384.226 409.447 408.278 404.345 426.232 390.321C459.496 364.338 458.562 317.142 451.35 279.683Z",
    fill: "#5F7EFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M451.35 279.683C451.014 277.94 450.665 276.217 450.303 274.517C441.138 231.432 422.69 186.93 389.8 156.56C375.552 143.404 358.322 133.361 339.118 129.743C315.675 125.326 291.305 131.444 269.769 141.703C248.233 151.962 228.9 166.216 208.938 179.275C196.049 187.707 182.417 195.833 167.211 198.284C149.001 201.219 130.366 195.723 112.004 197.468C83.2 200.205 57.817 221.684 47.444 248.695C37.071 275.706 40.824 307.055 54.499 332.554C68.174 358.053 91.044 377.911 116.84 391.017C152.593 409.182 194.871 414.858 233.745 405.003C252.704 400.196 271.084 391.795 290.64 391.447C314.901 391.016 337.625 403.018 361.662 406.334C384.226 409.447 408.278 404.345 426.232 390.321C459.496 364.338 458.562 317.142 451.35 279.683Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M381.214 173.947C377.962 172.174 376.484 173.651 375.302 172.174C374.12 170.696 378.554 166.853 369.685 163.01C369.685 163.01 369.094 154.733 356.974 154.437C344.854 154.141 348.106 162.714 344.854 164.783C341.602 166.852 340.716 163.601 337.464 165.67C334.212 167.739 335.69 171.878 333.03 172.469C330.369 173.06 326.822 169.808 323.57 171.878C320.318 173.947 320.318 175.721 318.84 175.721C317.362 175.721 314.406 174.539 312.632 175.721C310.858 176.903 308.789 178.382 308.789 178.382H383.578C383.578 178.382 384.466 175.721 381.214 173.947Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M381.214 173.947C377.962 172.174 376.484 173.651 375.302 172.174C374.12 170.696 378.554 166.853 369.685 163.01C369.685 163.01 369.094 154.733 356.974 154.437C344.854 154.141 348.106 162.714 344.854 164.783C341.602 166.852 340.716 163.601 337.464 165.67C334.212 167.739 335.69 171.878 333.03 172.469C330.369 173.06 326.822 169.808 323.57 171.878C320.318 173.947 320.318 175.721 318.84 175.721C317.362 175.721 314.406 174.539 312.632 175.721C310.858 176.903 308.789 178.382 308.789 178.382H383.578C383.578 178.382 384.466 175.721 381.214 173.947Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M254.546 369.947C251.294 368.174 249.816 369.651 248.634 368.174C247.452 366.696 251.886 362.853 243.017 359.01C243.017 359.01 242.426 350.733 230.306 350.437C218.186 350.142 221.438 358.714 218.186 360.783C214.934 362.852 214.047 359.601 210.796 361.67C207.544 363.739 209.022 367.878 206.362 368.469C203.701 369.06 200.154 365.809 196.902 367.878C193.65 369.947 193.65 371.721 192.172 371.721C190.694 371.721 187.738 370.539 185.964 371.721C184.19 372.903 182.121 374.381 182.121 374.381H256.91C256.91 374.381 257.798 371.721 254.546 369.947Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M254.546 369.947C251.294 368.174 249.816 369.651 248.634 368.174C247.452 366.696 251.886 362.853 243.017 359.01C243.017 359.01 242.426 350.733 230.306 350.437C218.186 350.142 221.438 358.714 218.186 360.783C214.934 362.852 214.047 359.601 210.796 361.67C207.544 363.739 209.022 367.878 206.362 368.469C203.701 369.06 200.154 365.809 196.902 367.878C193.65 369.947 193.65 371.721 192.172 371.721C190.694 371.721 187.738 370.539 185.964 371.721C184.19 372.903 182.121 374.381 182.121 374.381H256.91C256.91 374.381 257.798 371.721 254.546 369.947Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M194.118 337.036C189.03 334.261 186.718 336.574 184.868 334.261C183.018 331.948 189.955 325.936 176.081 319.924C176.081 319.924 175.156 306.974 156.194 306.512C137.232 306.05 142.319 319.462 137.232 322.699C132.145 325.936 130.757 320.849 125.67 324.087C120.582 327.324 122.895 333.799 118.733 334.725C114.571 335.65 109.021 330.562 103.933 333.8C98.8456 337.037 98.8456 339.812 96.5326 339.812C94.2206 339.812 89.5946 337.962 86.8206 339.812C84.0456 341.662 80.8086 343.974 80.8086 343.974H197.819C197.819 343.974 199.206 339.812 194.118 337.036Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M194.118 337.036C189.03 334.261 186.718 336.574 184.868 334.261C183.018 331.948 189.955 325.936 176.081 319.924C176.081 319.924 175.156 306.974 156.194 306.512C137.232 306.05 142.319 319.462 137.232 322.699C132.145 325.936 130.757 320.849 125.67 324.087C120.582 327.324 122.895 333.799 118.733 334.725C114.571 335.65 109.021 330.562 103.933 333.8C98.8456 337.037 98.8456 339.812 96.5326 339.812C94.2206 339.812 89.5946 337.962 86.8206 339.812C84.0456 341.662 80.8086 343.974 80.8086 343.974H197.819C197.819 343.974 199.206 339.812 194.118 337.036Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M247.523 71.5703C212.613 71.5703 184.218 97.0373 183.236 128.788L155.721 143.856L141.264 130.122L120.385 161.821L105.844 161.205L113.307 190.131L113.951 166.325L124.246 168.255L141.264 150.362L158.613 164.096L185.803 147.102C193.639 171.543 218.298 189.396 247.524 189.396C283.055 189.396 311.858 163.02 311.858 130.483C311.857 97.9463 283.054 71.5703 247.523 71.5703Z",
    fill: "#AFBFFD",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M304.515 169.882H188.449C185.23 169.882 182.621 167.273 182.621 164.054V98.0077C182.621 94.7887 185.23 92.1797 188.449 92.1797H304.515C307.734 92.1797 310.343 94.7887 310.343 98.0077V164.054C310.342 167.273 307.733 169.882 304.515 169.882Z",
    fill: "#FBF75F",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M251.581 129.087L310.343 99.3627V98.0067C310.343 94.7887 307.734 92.1797 304.515 92.1797H188.449C185.23 92.1797 182.621 94.7887 182.621 98.0067V99.6207L240.306 129.226C243.876 130.961 248.055 130.91 251.581 129.087Z",
    fill: "#FBF75F",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M318.42 106.196C319.54 113.071 314.875 119.552 308 120.672C301.125 121.792 294.644 117.127 293.524 110.252C292.404 103.377 297.069 96.8958 303.944 95.7757C310.819 94.6557 317.3 99.3209 318.42 106.196Z",
    fill: "white",
    stroke: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M305.185 115.738C304.877 115.394 304.723 114.906 304.723 114.275L304.712 102.607L302.414 104.017C302.24 104.135 302.039 104.195 301.809 104.195C301.493 104.195 301.225 104.073 301.004 103.828C300.783 103.583 300.672 103.299 300.672 102.975C300.672 102.549 300.876 102.209 301.287 101.956L305.481 99.4799C305.804 99.2829 306.124 99.1799 306.44 99.1719C306.906 99.1719 307.287 99.3419 307.583 99.6809C307.879 100.021 308.027 100.503 308.027 101.126L308.039 114.345C308.039 114.922 307.88 115.384 307.565 115.731C307.249 116.079 306.851 116.252 306.369 116.252C305.889 116.253 305.494 116.081 305.185 115.738Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M183.5 281.764C183.5 281.764 223 341.264 232.5 342.264C242 343.264 272 312.264 272 312.264L263.5 310.264L235.193 329.401C235.193 329.401 210.974 299.704 189.737 276.984L183.5 281.764Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M190.527 264.031C190.527 264.031 198.455 264.376 198.11 267.822C197.765 271.269 198.11 280.575 196.042 282.298C193.974 284.021 190.872 284.711 190.183 281.264C189.493 277.818 190.527 264.031 190.527 264.031Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M188.459 280.234C188.459 280.234 188.114 290.574 187.425 291.608C186.736 292.642 181.91 296.433 178.808 295.744C175.706 295.055 176.74 291.953 176.74 290.229C176.74 288.506 176.74 263 176.74 263H188.459V280.234Z",
    fill: "black",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M172.261 284.027C172.261 284.027 169.848 288.508 171.916 291.954C173.984 295.401 179.843 295.401 182.256 293.677C184.669 291.954 182.945 289.541 180.877 288.851C178.809 288.162 176.052 286.438 176.052 284.37C176.052 282.303 173.295 282.648 172.261 284.027Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M170.387 277.47C170.409 279.825 170.788 283.791 172.645 285.428C174.749 287.282 184.413 287.41 188.614 284.599C192.814 281.788 190.025 276.895 186.818 277.21C184.158 277.47 181.306 276.814 178.613 276.475C177.092 276.284 171.728 275.1 170.675 276.213C170.413 276.49 170.385 276.965 170.387 277.399C170.386 277.422 170.386 277.446 170.387 277.47Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M169.205 268.921C168.873 271.3 168.718 275.324 170.671 277.064C172.885 279.036 184.327 279.625 189.737 276.986C195.147 274.347 192.584 269.273 188.732 269.438C185.537 269.574 182.255 268.776 179.112 268.306C177.338 268.041 171.155 266.59 169.737 267.664C169.384 267.931 169.278 268.41 169.215 268.848C169.211 268.873 169.208 268.897 169.205 268.921Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M169.871 257.144C169.021 259.391 167.981 263.281 169.502 265.41C171.225 267.823 182.255 270.925 188.114 269.546C193.973 268.167 192.595 262.653 188.801 261.963C185.655 261.39 182.63 259.886 179.669 258.734C177.997 258.083 172.288 255.302 170.667 256.036C170.263 256.219 170.054 256.662 169.896 257.076C169.889 257.098 169.88 257.121 169.871 257.144Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M261.566 429.964L293.066 312.203H303.728L270.29 430.933",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M261.566 429.964L293.066 312.203H303.728L270.29 430.933",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M282.431 418.701L312.935 311.719L303.727 312.204L270.289 430.934",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M282.431 418.701L312.935 311.719L303.727 312.204L270.289 430.934",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M279.496 428.994L280.907 424.047",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M240.504 339.864C240.504 339.864 243.951 345.034 248.087 345.723C252.223 346.412 295.997 311.945 295.997 311.945L278.074 314.013L240.504 339.864Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M212.715 284.582C212.715 284.582 220.953 216.252 239.369 192.505C259.505 166.54 299.946 187.659 291.707 229.336C285.385 261.316 266.992 318.505 266.992 318.505L212.715 284.582Z",
    fill: "#5F7EFB",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M271.838 183.781L379.516 217.809C383.038 218.922 386.285 220.79 388.945 223.353C395.733 229.892 405.858 243.958 397.353 264.711C386.718 290.661 369.73 309.78 369.73 309.78L266.992 318.503L287.83 238.057C287.83 238.058 297.522 202.681 271.838 183.781Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10743_2082",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 266,
    y: 183,
    width: 135,
    height: 136
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M271.838 183.781L379.516 217.809C383.038 218.922 386.285 220.79 388.945 223.353C395.733 229.892 405.858 243.958 397.353 264.711C386.718 290.661 369.73 309.78 369.73 309.78L266.992 318.503L287.83 238.057C287.83 238.058 297.522 202.681 271.838 183.781Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10743_2082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.333 278.435C296.432 290.576 282.583 288.465 275.688 284.934L266.992 318.506L369.73 309.783C369.73 309.783 386.718 290.664 397.353 264.714C398.553 261.785 399.371 258.994 399.891 256.334C374.927 250.45 355.128 263.062 322.333 278.435Z",
    fill: "#5F7EFB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_10743_2082",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 266,
    y: 183,
    width: 135,
    height: 136
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M271.838 183.781L379.516 217.809C383.038 218.922 386.285 220.79 388.945 223.353C395.733 229.892 405.858 243.958 397.353 264.711C386.718 290.661 369.73 309.78 369.73 309.78L266.992 318.503L287.83 238.057C287.83 238.058 297.522 202.681 271.838 183.781Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_10743_2082)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M322.333 278.435C296.432 290.576 282.583 288.465 275.688 284.934L266.992 318.506L369.73 309.783C369.73 309.783 386.718 290.664 397.353 264.714C398.553 261.785 399.371 258.994 399.891 256.334C374.927 250.45 355.128 263.062 322.333 278.435Z",
    fill: "white"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M271.838 183.781L379.516 217.809C383.038 218.922 386.285 220.79 388.945 223.353C395.733 229.892 405.858 243.958 397.353 264.711C386.718 290.661 369.73 309.78 369.73 309.78L266.992 318.503L287.83 238.057C287.83 238.058 297.522 202.681 271.838 183.781Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M332.361 193.922L315.496 246.54C312.63 247.018 309.832 249.383 308.441 252.874C306.519 257.697 308.011 262.822 311.773 264.321C315.535 265.82 320.142 263.125 322.064 258.303C323.646 254.332 322.911 250.162 320.503 247.974L332.361 207.46L348.905 213.1L353.417 201.444L332.361 193.922Z",
    fill: "black",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M229.332 240.544C229.332 240.544 236.852 248.816 237.228 252.952C237.604 257.088 230.836 267.992 230.836 267.992C230.836 267.992 244.748 276.64 257.909 270.624C271.069 264.608 277.461 239.039 277.461 239.039C277.461 239.039 261.669 246.559 255.652 246.559C249.636 246.561 229.332 240.544 229.332 240.544Z",
    fill: "black",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M257.91 270.629C261.54 268.969 264.653 265.819 267.261 262.131C266.758 260.504 265.726 259.316 263.926 258.973C256.03 257.469 247.758 266.117 247.758 266.117C247.758 266.117 246.889 268.148 246.422 272.717C250.066 272.899 254.02 272.408 257.91 270.629Z",
    fill: "#5F7EFB",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M247.005 263.86C240.831 263.566 236.51 261.439 234.912 260.523C233.08 264.38 230.836 267.997 230.836 267.997C230.836 267.997 244.748 276.645 257.909 270.629C261.305 269.077 264.246 266.218 266.747 262.837C263.663 263.171 253.621 264.175 247.005 263.86Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M255.653 246.568C249.637 246.568 229.332 240.552 229.332 240.552C229.332 240.552 233.633 245.286 235.891 249.383C240.876 251.388 249.68 254.464 256.78 254.464C263.207 254.464 269.769 252.221 273.996 249.362C276.312 243.627 277.461 239.047 277.461 239.047C277.461 239.047 261.67 246.568 255.653 246.568Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M254.148 229.264C254.148 229.264 256.404 221.368 262.796 220.616C269.188 219.864 271.068 224.376 271.068 224.376C271.068 224.376 259.037 224.376 254.148 229.264Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M272.574 236.789L281.974 240.173",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M243.59 221.7C243.117 224.358 241.905 226.365 240.883 226.183C239.861 226.001 239.415 223.699 239.888 221.041C240.361 218.383 241.573 216.376 242.596 216.558C243.618 216.74 244.063 219.042 243.59 221.7Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M255.653 219.867C255.653 219.867 255.277 215.355 265.053 215.355C274.829 215.355 276.709 214.227 272.949 209.339C269.19 204.45 253.397 207.083 255.653 219.867Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M251.892 206.33C251.892 206.33 251.14 199.938 245.124 199.938C239.108 199.938 235.724 207.082 235.348 204.826C234.972 202.57 237.228 194.674 245.5 193.922C253.772 193.17 251.892 206.33 251.892 206.33Z",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M294.315 201.117C295.667 204.358 296.757 208.503 297.219 213.782C299.62 241.219 275.27 315.984 275.27 315.984",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M284.871 190.117C284.871 190.117 287.524 191.075 290.393 194.512",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M369.816 302.805C367.441 306.386 365.812 308.783 365.812 308.783",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M373.698 217.211C373.698 217.211 391.875 227.5 394.276 242.59C396.677 257.68 390.846 265.568 387.417 273.799C385.452 278.514 378.649 289.306 373.195 297.665",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M231.762 275.656C231.762 275.656 237.195 281.089 249.419 279.731C249.419 279.731 237.195 285.163 231.762 275.656Z",
    fill: "black"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M121.938 271.271C121.938 271.271 153.768 254.583 211.87 264.808C217.429 265.786 222.737 262.078 223.732 256.522L224.573 251.829C225.403 247.194 222.974 242.597 218.678 240.669C203.248 233.741 167.353 214.522 148.478 178.898L121.938 271.271Z",
    fill: "#F3475D",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M150.371 198.242C150.371 198.242 165.917 222.621 191.709 231.454",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M218.678 240.669C212.513 237.901 203.079 233.165 192.772 226.211C195.485 234.874 196.265 247.965 185.047 261.749C193.247 262.16 202.186 263.104 211.872 264.808C217.431 265.786 222.738 262.078 223.733 256.522L224.573 251.829C225.403 247.194 222.974 242.597 218.678 240.669Z",
    fill: "black",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M147.44 229C156.507 200.011 154.8 173.678 143.627 170.183C132.454 166.689 116.046 187.356 106.979 216.346C97.9126 245.335 99.62 271.669 110.793 275.163C121.966 278.658 138.373 257.99 147.44 229Z",
    fill: "black",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M142.94 227.593C151.097 201.513 150.114 177.996 140.745 175.065C131.376 172.135 117.168 190.901 109.011 216.981C100.855 243.061 101.837 266.579 111.207 269.509C120.576 272.439 134.783 253.673 142.94 227.593Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M146.688 212.64L137.394 212.148L130.434 235.968L137.825 241.294C139.692 237.039 141.42 232.439 142.939 227.584C144.541 222.457 145.785 217.432 146.688 212.64Z",
    fill: "black",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M137.926 225.226C136.004 231.804 132.65 236.611 130.435 235.964C128.22 235.317 127.983 229.46 129.905 222.882C131.827 216.304 135.181 211.497 137.396 212.144C139.61 212.791 139.848 218.648 137.926 225.226Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M244.298 344.338C239.128 341.925 196.733 266.442 194.321 262.306C191.908 258.17 192.598 252.311 195.01 246.796C197.423 241.281 197.423 230.941 196.044 228.873C194.665 226.805 190.414 224.694 190.414 224.694C190.414 224.694 191.218 223.703 192.942 221.635C194.665 219.567 198.801 220.946 198.801 220.946C201.903 218.533 204.674 222.472 204.674 222.472C208.121 220.404 209.831 224.393 209.831 224.393C209.831 224.393 211.83 224.491 213.278 225.427C216.156 227.287 215.691 235.422 215.691 235.422C215.691 235.422 218.793 236.111 219.482 238.179C220.171 240.247 220.171 244.728 218.793 248.174C217.414 251.621 208.798 261.961 208.798 261.961L251.538 335.376",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M244.298 344.338C239.128 341.925 196.733 266.442 194.321 262.306C191.908 258.17 192.598 252.311 195.01 246.796C197.423 241.281 197.423 230.941 196.044 228.873C194.665 226.805 190.414 224.694 190.414 224.694C190.414 224.694 191.218 223.703 192.942 221.635C194.665 219.567 198.801 220.946 198.801 220.946C201.903 218.533 204.674 222.472 204.674 222.472C208.121 220.404 209.831 224.393 209.831 224.393C209.831 224.393 211.83 224.491 213.278 225.427C216.156 227.287 215.691 235.422 215.691 235.422C215.691 235.422 218.793 236.111 219.482 238.179C220.171 240.247 220.171 244.728 218.793 248.174C217.414 251.621 208.798 261.961 208.798 261.961L251.538 335.376",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M198.801 220.945C198.801 220.945 203.748 224.138 203.748 226.916C203.748 229.694 204.304 233.398 204.304 233.398",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M204.676 222.469C204.676 222.469 207.639 225.617 207.824 227.469C208.009 229.321 208.38 235.062 208.38 235.062",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M209.832 224.391C209.832 224.391 211.527 226.73 211.527 229.508C211.527 232.286 211.897 235.249 211.897 235.249",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M215.691 235.422C215.691 235.422 217.082 244.324 216.527 246.176",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.0d3b4df46e3496d55410f7af9485bef8.svg";
export { ForwardRef as ReactComponent };